export function formatBrl(value: number): string {
	return 'R$ ' + Math.round(value).toLocaleString('pt-BR');
}

export function formatPercent(value: number, decimals: number): string {
	return value.toFixed(decimals).replace('.', ',') + '%';
}

export function formatPlainInput(value: number): string {
	return value > 0 ? String(Math.round(value)) : '';
}

export function parseDigits(text: string): number {
	return Number(text.replace(/\D/g, '')) || 0;
}

export function clampNumber(value: number, min: number, max: number): number {
	return Math.min(max, Math.max(min, value));
}

export function maskCpf(text: string): string {
	const digits = text.replace(/\D/g, '').slice(0, 11);
	if (digits.length > 9) {
		return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
	}
	if (digits.length > 6) {
		return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
	}
	if (digits.length > 3) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
	return digits;
}

export function getCpfDigits(text: string): string {
	return text.replace(/\D/g, '');
}

function getCheckDigit(digits: string, length: number): number {
	let sum = 0;
	for (let index = 0; index < length; index++) {
		sum += Number(digits[index]) * (length + 1 - index);
	}
	const remainder = (sum * 10) % 11;
	return remainder === 10 ? 0 : remainder;
}

export function isValidCpf(text: string): boolean {
	const digits = getCpfDigits(text);
	if (digits.length !== 11 || /^(\d)\1{10}$/.test(digits)) return false;
	return (
		getCheckDigit(digits, 9) === Number(digits[9]) &&
		getCheckDigit(digits, 10) === Number(digits[10])
	);
}
